// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 606) return "static/chunks/606.b10335ac76503866.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"673":"7406121bea9098f5","3007":"c5bf1ed4a43ecdb9","6923":"0155c33fb0c56429","7668":"1b8519931a22482f"}[chunkId] + ".js";
};